import { DispatchAction, CartActionType, CartItem } from "modules/cart/types/cart";


export const updateLocalStorage = (state:CartItem[]) => {
    // Persist resolved items only
    const persistable = state.filter(
        (item) => !item.is_pending_resolution,
    );
    window.localStorage.setItem('cart', JSON.stringify(persistable))
};

const getCartInitialState = ():Array<CartItem> => {
    const cart = JSON.parse(window.localStorage.getItem('cart') || '[]');    
    return cart;
}

export const cartInitialState:Array<CartItem> = getCartInitialState();

const getNewState = (curIndex:number, state:Array<CartItem>, product:CartItem):Array<CartItem> => {
    const safePriceComponents = Array.isArray(product.price_component) ? product.price_component : [];
    const total_qty = safePriceComponents.reduce((acc, pc) =>  (acc + pc.quantity  ) ,0);
    if (total_qty <= 0 && curIndex >= 0)
        return [
            ...state.slice(0, curIndex),
            ...state.slice(curIndex + 1)
        ];

    if (curIndex >= 0 )
        return [
            ...state.slice(0, curIndex),
            {
                ...product,
                price_component: safePriceComponents,
            },
            ...state.slice(curIndex + 1)
        ];
    if (total_qty >0)      
        return [
            ...state,
            {
                ...product,
                price_component: safePriceComponents,
            }
        ];   
    return state;
}

const UPDATE_STATE_BY_ACTION : Record<CartActionType, (state: Array<CartItem>, action: DispatchAction) => Array<CartItem>> = {
    
    
    [CartActionType.AddDeletefromCart]: (state:Array<CartItem>, action:DispatchAction) => {   
        
        const {payload} = action;
        if(!payload || !("product" in payload))
            throw new Error("Not implemented");

        const currIndex = state.findIndex((item:CartItem) => item.id === payload?.product?.id);

        const newState = getNewState(
            currIndex, state, payload.product as CartItem
        );      
        updateLocalStorage(newState);    
        return newState         
    },
    [CartActionType.RemoveFromCart]: (state:Array<CartItem>, action:DispatchAction) => {
        const {payload} = action;
        if(!payload || !("product" in payload))
            throw new Error("Not implemented");
        const currIndex = state.findIndex((item:CartItem) => item.id === payload?.product?.id);
        const newState =  getNewState(
            currIndex,state, payload?.product ?? {} as CartItem
        );
        updateLocalStorage(newState);  
        return newState

    },
    [CartActionType.ClearCart]: () => {
        updateLocalStorage([]);  
        return [];
    },

    [CartActionType.RefreshCart]:(state:CartItem[], action:DispatchAction) => {
        const {payload} = action;
        if (!payload || !("cart" in payload)) return state;
        updateLocalStorage(payload.cart ?? []);  
        return payload.cart ? payload.cart : state;
    },
    
    [CartActionType.Recalculate]: (state:Array<CartItem>, action:DispatchAction) => {
        const {payload} = action;
        if(!payload || !("product" in payload))
            throw new Error("Not implemented");
        const currIndex = state.findIndex((item:CartItem) => item.id === payload?.product?.id);

        const newState = getNewState(
            currIndex, state, payload?.product ?? {} as CartItem
        );      
        updateLocalStorage(newState);  
        return newState    
    },
    [CartActionType.ReplaceCart]: (state:Array<CartItem>, action:DispatchAction) => {
        const {payload} = action;
        if(!payload || !("cart" in payload))
            throw new Error("Not implemented");
        const newState = payload.cart || [];
        updateLocalStorage(newState);  
        return newState    
    },
    [CartActionType.Validating]: (state:Array<CartItem>, action:DispatchAction) => {
        return state    
    },
    [CartActionType.SetDecision]: (state:Array<CartItem>, action:DispatchAction) => {
        const {payload} = action;
        if (!payload || !("productDecision" in payload)) return state;
        const updatedState = state.map((item) =>
            item.id === payload.id
                ? { ...item, productDecision: payload.productDecision }
                : item
        );
        updateLocalStorage(updatedState);
        return updatedState;
    },
};

export const cartReducer = (state:Array<CartItem>, action:DispatchAction):Array<CartItem> => 
{   
    const updateStateFunction = UPDATE_STATE_BY_ACTION[action.type];
    if (updateStateFunction) {
        return updateStateFunction(state, action);
    }
    return state;
}